const prefix = 'nxt';
const iconName = 'chime';
const width = 16;
const height = 16;
const ligatures = [];
const unicode = '';
const svgPathData = [
  'M10.5225 7.71579V5.91443L9.85205 6.2516L10.5225 7.71658V7.71579Z',
  'M12.1849 6.4655L14.9673 3.68384L10.5225 5.91447L12.1849 6.4655Z',
  'M10.5226 8.08118L9.96069 9.59298L9.96225 9.59142L11.236 8.31766L12.022 9.88254H15.9556L10.5226 8.08118Z',
  'M10.5225 5.91443V7.71579H15.9554L12.1849 6.46545L10.5225 5.91443Z',
  'M10.5225 7.71582V7.7166V8.08109L15.9554 9.88246V7.71582H10.5225Z',
  'M8.24658 10.517H10.0378L9.48678 12.1794L12.2716 14.965L9.70453 9.84888L8.24658 10.517Z',
  'M9.96216 9.59138L13.8029 13.4329L12.0219 9.88251L11.2359 8.31763L9.96216 9.59138Z',
  'M9.96215 9.59131L9.96059 9.59287L9.70459 9.84887L12.2716 14.965L13.8029 13.4329L9.96215 9.59131Z',
  'M6.35939 9.95435L6.36095 9.95669L7.6347 11.2304L6.06982 12.0156V15.9493L7.87197 10.5171L6.35939 9.95435Z',
  'M8.24672 10.517H8.23657V15.9492L9.48691 12.1794L10.0379 10.517H8.24672Z',
  'M8.23646 10.517H7.87197L6.06982 15.9492H8.23646V10.517Z',
  'M3.7697 9.48364L0.988037 12.2661L5.43213 10.0354L3.7697 9.48364Z',
  'M5.43213 8.23328V10.0354L6.10335 9.69825L5.43213 8.23328Z',
  'M6.36109 9.95667L2.51953 13.7974L6.06997 12.0156L7.63485 11.2304L6.36109 9.95667Z',
  'M6.36092 9.95658L6.35935 9.95424L6.10335 9.69824L5.43213 10.0354L0.988037 12.266L2.51935 13.7974L6.36092 9.95658Z',
  'M5.99493 6.35629L5.99337 6.35863L4.71883 7.63238L3.93366 6.0675H0L5.4322 7.86887L5.99493 6.35629Z',
  'M5.4322 10.0354V8.23328H0L3.76976 9.48362L5.4322 10.0354Z',
  'M5.4322 8.23335V7.86887L0 6.0675V8.23335H5.4322Z',
  'M7.70881 5.43298H5.91681L6.46862 3.77055L3.68384 0.984985L6.25086 6.1003L7.70881 5.43298Z',
  'M5.99342 6.35853L2.15186 2.51697L3.93371 6.06741L4.71888 7.63228L5.99342 6.35853Z',
  'M5.99342 6.35864L5.99498 6.3563L6.25098 6.1003L3.68395 0.984985L2.15186 2.51708L5.99342 6.35864Z',
  'M9.59608 5.99488L9.59374 5.99332L8.31998 4.71956L9.88486 3.93439V0.000732422L8.0835 5.43293L9.59608 5.99488Z',
  'M7.70899 5.43293H7.71914V0.000732422L6.4688 3.77049L5.91699 5.43293H7.70899Z',
  'M7.71899 5.43293H8.08348L9.88485 0.000732422H7.71899V5.43293Z',
  'M9.59382 5.99337L13.4354 2.15259L9.88495 3.93444L8.32007 4.71961L9.59382 5.99337Z',
  'M9.59375 5.99337L9.59609 5.99493L9.85209 6.25171L10.5225 5.91454L14.9674 3.6839L13.4353 2.15259L9.59375 5.99337Z',
];

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtChime = definition;

export { definition, nxtChime, prefix, iconName, width, height, ligatures, unicode, svgPathData };
